<template>
	<script type="text/x-template" id="template-magic-mode" class="template">

		<li class="block edit_block magic-mode-block adjustment-block preview-based disabled">
		    <div class="header-container edit_block_header drag_handle">
		        <label class="lookup_block_name name">Magic mode</label>
		    </div>

		    <div class="block_options">
		        <div class="magic-mode-controls-container"></div>

		        <div class="lut-selector">
		            <div class="lut-selector__label-container">
		                <span class="selected-lut-name">Select...</span>
		                <i class="material-icons">expand_more</i>
		                <i class="btn-reset-selection material-icons" data-tippy-content="Remove selection">settings_backup_restore</i>
		            </div>
		            <div class="lut-selector__items-container"></div>
		        </div>

		        <div class="block-sliders-container">
		            <span class="slider-name">Opacity</span>
		            <input type="range" min="0" max="100" value="100" data-default-value="100" class="range_slider opacity_slider">
		            <input type="number" class="lookup_range_value range_value opacity-input" value="100" min="1" max="100">
		        </div>
		    </div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
